import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material.module';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
   selector: 'app-language',
   standalone: true,
   imports: [CommonModule, MaterialModule, TranslateModule],
   templateUrl: './language.component.html',
})
export class LanguageComponent implements OnInit {
   // Injections
   private localStorageService = inject(LocalStorageService);
   private translate = inject(TranslateService);

   // Variables
   public selectedLanguage: any = {
      language: 'Português',
      code: 'pt-BR',
      icon: '/assets/images/flag/icon-flag-pt-BR.svg',
   };

   public languages: any[] = [
      {
         language: 'English',
         code: 'en',
         type: 'US',
         icon: '/assets/images/flag/icon-flag-en.svg',
      },
      {
         language: 'Español',
         code: 'es',
         icon: '/assets/images/flag/icon-flag-es.svg',
      },
      {
         language: 'Português',
         code: 'pt-BR',
         icon: '/assets/images/flag/icon-flag-pt-BR.svg',
      },
      {
         language: 'Português',
         code: 'pt-PT',
         icon: '/assets/images/flag/icon-flag-pt-PT.svg',
      },
   ];

   ngOnInit() {
      const langCode = this.localStorageService.getLanguage();
      this.translate.setFallbackLang(langCode || 'pt-BR');

      if (langCode) {
         this.translate.use(langCode);
         this.selectedLanguage =
            this.languages.find((n) => n.code === langCode) || this.selectedLanguage;
      }
   }

   /** Change Language */
   onChangeLanguage(lang: any): void {
      this.translate.use(lang.code);
      this.selectedLanguage = lang;

      this.localStorageService.setLanguage(lang.code);
   }
}
